<template>
  <div class="content bg-white">
    <div class="menu-content d-flex rounded-md mb-2">
      <div class="item-media ">
        <img v-if="order.menu_image" style="border-radius: 10px;" :src="order.menu_image" alt="food">
        <img v-else-if="isBarMenu" style="border-radius: 10px;" src="../assets/menu_bar.png">
        <img v-else style="border-radius: 10px;" src="../assets/menu_kitchen.png">
      </div>
      <div  class="item-description align-items-center justify-content-center text-start flex-1 ml-4">
        <div @click="showContent">
          <p class="mb-0 text-black">{{order?.menu_name}}</p>
          <p v-if="order.comment" class="sub-com mb-0">  <i class="fa-solid text-secondary fa-comment me-1"></i>{{order.comment}}</p>
          <p class="mb-0 text-success">{{order.total}} f</p>
        </div>
        <div class="align-middle dropdown end-0 top-35 position-absolute me-2">
          <button class="btn-action dropdown-toggle" data-bs-toggle="dropdown"> <i class="fa fa-ellipsis-v"></i> </button>
          <div class="dropdown-menu">
            <router-link :to="{name: 'edit-menu-page', params: {id: order.menu_id}, query:{index: index}}" class="dropdown-item" @click.prevent="updateOrder">Modifier</router-link>
            <a class="dropdown-item" @click.prevent="deleteOrder">Supprimer</a>
          </div>
        </div>
      </div>
    </div>
    <div :id="'details' + index" style="display: none">
      <div v-if="order.meals.length > 0" id="meals" class="mb-3">
        <p class="text-black mb-0 text-start font-13 section-title mb-2">Variation</p>
        <div v-for="(meal, index) in order.meals" :key="meal.id" class="extra-name text-start mb-1 pt-1 pb-1" :class="index%2 != 1 ? 'border-bottom' : ''">
          <div class="d-flex d-flex justify-content-between ">
            <small class="mb-0 extra-elm">{{ meal?.name }}</small>
            <small class="mb-0 extra-elm">{{ $t('TOTAL') }}</small>
          </div>
          <div class="d-flex d-flex justify-content-between ">
            <small class="mb-0 text-success extra-elm">{{ parseFloat(meal?.price) }}f  <span class="bold text-dark font-12">x {{ meal?.quantity }}</span></small>
            <small class="mb-0 extra-elm bold text-primary">{{ parseFloat(meal?.quantity) * parseFloat(meal?.price) }}f</small>
          </div>
        </div>
      </div>
      <div v-if="order.accompaniements.length > 0" id="accompaniements" class="mb-3">
        <p class="mb-0 text-black text-start font-13 section-title mb-2">Acompagnements</p>
        <div v-for="(accompaniement, index) in order.accompaniements" :key="accompaniement.id" class="d-flex justify-content-between extra-name text-start" :class="index%2 != 1 ? 'border-bottom' : ''">
          <small class="mb-0 extra-elm">{{ accompaniement?.name }}</small>
          <small class="bold mb-0 extra-elm"> {{ accompaniement?.quantity }} </small>
        </div>
      </div>
      <div v-if="order.supplements.length > 0" id="extras" >
        <p class="mb-0 text-black text-start font-13 section-title mb-2">Suppléments</p>
        <div v-for="(supplement, index) in order.supplements" :key="supplement.id" class="extra-name text-start mb-1 pt-1 pb-1" :class="index%2 != 1 ? 'border-bottom' : ''">
          <div class="d-flex d-flex justify-content-between ">
            <small class="mb-0 extra-elm">{{ supplement?.name }}</small>
            <small class="mb-0 extra-elm">{{ $t('TOTAL') }}</small>
          </div>
          <div class="d-flex d-flex justify-content-between ">
            <small class="mb-0 text-success extra-elm">{{ parseFloat(supplement?.price) }}f  <span class="bold text-dark font-12">x {{ supplement?.quantity }}</span></small>
            <small class="mb-0 extra-elm bold text-primary">{{ parseFloat(supplement?.quantity) * parseFloat(supplement?.price) }}f</small>
          </div>
        </div>
      </div>
      <div v-if="order.comment != ''" class="instructions bx-border-radius p-2 mb-3">
        <p class="mb-0 text-black bold text-start font-13 mb-2">Instructions</p>
        <p class="mb-0 flex-wrap text-start">{{ order.comment }}</p>
      </div>
    </div>
  </div>
</template>


<script setup>

import {computed, onMounted} from "vue";
import {useStore} from "vuex";

// eslint-disable-next-line no-undef
const props = defineProps({
  order: {
    type: Object,
    default: () => {
      return {
        menu_id: '',
        menu_name: '',
        menu_image: '',
        comment: '',
        supplements: [],
        meals: [],
        accompaniements: [],
      }
    }
  },
  name: {
    type: String,
    default: "Category"
  },
  id: {
    type: String,
    default: "1"
  },
  index: {
    type: Number,
  }
})

const isBarMenu = computed(() => {
  return props.order.cooking_place == 'BAR'
})

const store = useStore()

onMounted(() => {
})

function showContent(){
  // eslint-disable-next-line no-undef
  $("#details" + props.index).toggle();
}

function updateOrder(){

}

function deleteOrder(){
  store.dispatch('cart/deleteOrderFromCart', props.index)
}
</script>

<style scoped>
.content{
  box-shadow: 0px 0px 15px 0 rgba(0, 0, 0, 0.08);
  border-radius: 10px;
}
.item-media img{
  height: 70px;
  width: 70px;
  object-fit: cover;
}
.menu-content, #extras, #accompaniements, #meals{
  padding: 5px;
}

.item-description{
  padding-left: 7px;
  position: relative;

}

.btn-action{
  background: transparent;
  border: 0px;
}
.section-title{
  background: rgba(224, 224, 224, 0.3);
 padding-left: 5px;
}
.bold{
  font-weight: bold;
}
.instructions{
  margin: 5px;
  border-radius: 5px;
  background-color: #f8f8ff80;
}
.sub-com{
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1; /* number of lines to show */
  line-clamp: 2;
  -webkit-box-orient: vertical;
  width: 90%;
}
.top-35{
  top: 35% !important;
}

</style>